import React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import FormattedMessage from "@irati/utils/lang";
import idHelper from "@irati/utils/id";
import { Body } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { StyledDiv } from "./styled";
var HomePagePopTart = function (props) {
    var id = idHelper("pop-tart", props);
    var show = props.show, onExit = props.onExit;
    return (React.createElement(CSSTransition, { classNames: "homepage-pop-tart", in: show, timeout: {
            enter: 300,
            exit: 300
        }, unmountOnExit: true },
        React.createElement(StyledDiv, { id: id },
            React.createElement(Grid, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Flex, { margin: "10px 0", justifyContent: "space-between", alignItems: "center" },
                            React.createElement(Flex, { alignItems: "center" },
                                React.createElement(Body, { weight: "semibold" },
                                    React.createElement(FormattedMessage, { id: "platform.homepage.popTart.title" })),
                                React.createElement(Body, { small: true, marginLeft: 1 },
                                    React.createElement(FormattedMessage, { id: "platform.homepage.popTart.text" }))),
                            React.createElement(Button, { primary: true, onClick: onExit },
                                React.createElement(FormattedMessage, { id: "platform.homepage.popTart.button" })))))))));
};
export default HomePagePopTart;
